import { useNavigate } from '@tanstack/react-router';
import { Avatar, Button, Flex, Typography } from 'antd';
import { ShieldAlert, TriangleAlert } from 'lucide-react';
import { useEffect } from 'react';

import { hideHtmlLoader } from './ui/utils/html';

import type { ErrorComponentProps } from '@tanstack/react-router';

export function Error({ error, reset }: ErrorComponentProps) {
  const navigate = useNavigate();

  useEffect(() => {
    hideHtmlLoader();
  }, []);

  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : 'Something went wrong';

  const isForbidden = message.toLowerCase().includes('not authorized');
  const title = isForbidden ? "You don't have access" : 'Something went wrong';
  const Icon = isForbidden ? ShieldAlert : TriangleAlert;

  return (
    <Flex
      data-testid="error-boundary"
      flex={1}
      vertical
      align="center"
      justify="center"
      style={{ padding: 24 }}
    >
      <Flex vertical align="center" gap={20} style={{ maxWidth: 420 }}>
        <Avatar
          size={56}
          icon={<Icon />}
          style={{ backgroundColor: '#fde3cf', color: '#f56a00' }}
        />
        <Typography.Title level={3} style={{ margin: 0 }}>
          {title}
        </Typography.Title>
        <Typography.Text type="secondary">{message}</Typography.Text>
        <Flex gap={8}>
          <Button type="primary" onClick={reset}>
            Try again
          </Button>
          <Button onClick={() => navigate({ to: '/' })}>Go home</Button>
        </Flex>
      </Flex>
    </Flex>
  );
}
